import React, { Component } from 'react'
import GeneralSettingsForm from '../forms/GeneralSettingsForm'

class GeneralTab extends Component {
    render() {
        return (
            <div className="general-tab">
                <GeneralSettingsForm />
            </div>
        )
    }
}

export default GeneralTab